import axios from "axios"

function getChaptersAsStudent({}, {}, params) {
    return axios.get(`api/v1/chapters`, { params })
}

function getChaptersAsTutor({ id }, {}, params) {
    if (!id) return axios.get(`/api/v1/students/chapters`, { params })
    else return axios.get(`/api/v1/students/${id}/chapters`, { params })
}

function getChaptersForStudents({}, {}, params) {
    return axios.get(`/api/v1/students/chapters`, { params })
}

function studentChapterFeelings({ id }, data) {
    return axios.post(`/api/v1/student-chapters/${id}/fill-quiz`, data)
}

function getChaptersBySchoolSubjectId({ schoolSubjectId }, {}, params) {
    return axios.get(`/api/v1/chapters/${schoolSubjectId}`, { params })
}

function getChapterSkillParts({ chapterId }, {}, params) {
    return axios.get(`/api/v1/chapters/${chapterId}/skill-parts`, { params })
}

// Unified Levenshtein-ranked search over chapters + skill_parts.
// Omit class + school_subject_id to run a global cross-class search (used by
// the chapter dropdown's "Voir dans toutes les classes" fallback).
function searchCurriculum({}, {}, params) {
    return axios.get(`/api/v1/curriculum/search`, { params })
}

export const chaptersService = {
    getChaptersAsStudent,
    getChaptersAsTutor,
    studentChapterFeelings,
    getChaptersForStudents,
    getChaptersBySchoolSubjectId,
    getChapterSkillParts,
    searchCurriculum,
}
